export const VERTICAL_PADDING = 100;
export const HORIZONTAL_PADDING = 42;
export const RECT_FOR_CORNER_SIZE = 25;
export const RECT_FOR_CORNER_SHOW_SIZE = 6;
export const VOTE_SELECTOR_RADIUS = 12;
export const VOTE_TOOLTIP_MARGIN = 12;
export const VOTE_TOOLTIP_WIDTH = 141;
export const VOTE_TOOLTIP_HEIGHT = 40;
export const AVAILABLE_WIDGETS_NAMES_FOR_VOTE = [
    "sticker",
    "shape",
    "image",
    "text",
    "textV2",
    "card",
];
